/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Missing_TitleInputs */

const cs_ebr_missing_title = /** @type {(inputs: Ebr_Missing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chybí ve feedu`)
};

const en_ebr_missing_title = /** @type {(inputs: Ebr_Missing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing from the feed`)
};

/**
* | output |
* | --- |
* | "Missing from the feed" |
*
* @param {Ebr_Missing_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_missing_title = /** @type {((inputs?: Ebr_Missing_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Missing_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_missing_title(inputs)
	return cs_ebr_missing_title(inputs)
});